/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { TimeTrackingEntry } from '../../data/types';

export type ActiveBillableTimerState = {
    activeTimeEntry?: TimeTrackingEntry,
}

export const useActiveBillableTimerState = () => {
    const activeTimerState = useSelector((state: RootState | any) => state.activeBillableTimer as ActiveBillableTimerState);
    return activeTimerState;
}

// Define the initial state using that type
const initialState: ActiveBillableTimerState = {
    activeTimeEntry: undefined,
}

export const activeBillableTimerSlice = createSlice({
    name: 'activeBillableTimer',
    initialState: initialState,
    reducers: {
        setActiveTimerAction: (state, action: PayloadAction<TimeTrackingEntry>) => {
            return {
                ...state,
                activeTimeEntry: action.payload
            }
        },
        clearActiveTimerAction: (state) => {
            return {
                ...state,
                activeTimeEntry: undefined
            }
        }
    }
})

export const { setActiveTimerAction, clearActiveTimerAction } = activeBillableTimerSlice.actions;

export default activeBillableTimerSlice.reducer;